var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settingMain"},[_c('NavbarBack',{attrs:{"title":"ตั้งค่าช่องทางรับชำระเงิน"}}),_c('div',{staticClass:"container"},[_c('DefaultDisplayStage',{attrs:{"fetching":_vm.fetching,"error":_vm.error,"nodata":_vm.nodata}}),_c('ListToggleSwitch',{attrs:{"data":_vm.data},on:{"click":_vm.onToggleClick}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }